import { axiosConToken } from "../helpers/axios";
import { typesCotizacion as types } from "../types/typesCotizacion";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../helpers/messageConfig";
import { PATH_VENTAS } from "../constants/routes";

const key = "msgcotizaciones";

export const cotizacionesStartLoad = ({
  fechaemision_after = null,
  fechaemision_before = null,
  search = null,
  page = 1,
  page_size = 10,
}) => {
  return async (dispatch) => {
    dispatch(cotizacionStatusLoading());
    try {
      const resp = await axiosConToken.get(`${PATH_VENTAS.cotizacion}`, {
        params: {
          fechaemision_after,
          fechaemision_before,
          search,
          page,
          page_size,
        },
      });
      const data = resp.data;
      dispatch(cotizacionLoaded(data));
    } catch (error) {
      validaMessagesErrors(error, key);
    } finally {
      dispatch(cotizacionStatusLoading(false));
    }
  };
};
export const cotizacionStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(`${PATH_VENTAS.cotizacion}`, data);
      const { msg, cotizacion } = resp.data;
      dispatch(cotizacionAdded(cotizacion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const cotizacionStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_VENTAS.cotizacion}${data.id}/`,
        data,
      );
      const { msg, cotizacion } = resp.data;
      dispatch(cotizacionUpdated(cotizacion));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const cotizacionStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_VENTAS.cotizacion}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(cotizacionDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const cotizacionLoaded = (cotizaciones) => ({
  type: types.cotizacionesLoaded,
  payload: cotizaciones,
});
const cotizacionAdded = (cotizacion) => ({
  type: types.cotizacionAdded,
  payload: cotizacion,
});
const cotizacionUpdated = (cotizacion) => ({
  type: types.cotizacionUpdated,
  payload: cotizacion,
});
const cotizacionDeleted = (cotizacion) => ({
  type: types.cotizacionDeleted,
  payload: cotizacion,
});
export const cotizacionSetActive = (cotizacion) => ({
  type: types.cotizacionSetActive,
  payload: cotizacion,
});
const cotizacionClearActive = () => ({
  type: types.cotizacionClearActive,
});
const detalleCotizacionSetActive = (detalle) => ({
  type: types.detalleCotizacionSetActive,
  payload: detalle,
});
const detalleCotizacionClearActive = () => ({
  type: types.detalleCotizacionClearActive,
});
export const cotizacionStatusLoading = (loading = true) => ({
  type: types.dataLoading,
  payload: loading,
});
// Extra Async Functions

export const getMonedas = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.cotizacion}get_monedas/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};

const getVendedores = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.cotizacion}get_vendedores/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
const getAlmacenesEmpleadoSelect = async (empleado) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.cotizacion}get_almacenes_byempledo/`,
      {
        params: { empleado },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
const get_pdf_cotizacion = async (cotizacion) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.cotizacion}get_pdf_cotizacion/`,
      {
        responseType: "blob",
        params: { cotizacion },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
const search_items_by_param = async (param) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.cotizacion}search_items_by_param/`,
      { params: { param } },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
export {
  cotizacionClearActive,
  getAlmacenesEmpleadoSelect,
  get_pdf_cotizacion,
  getVendedores,
  detalleCotizacionSetActive,
  detalleCotizacionClearActive,
  search_items_by_param,
};
